import type { ReportType } from '../../Analytics.types'
import type { AnalyticsFiltersGroup } from './components/AnalyticsFilterSelect/AnalyticsFiltersSelect.types'

const createProfitFilters = ({
  membershipsEnabled,
}: {
  membershipsEnabled: boolean
}): AnalyticsFiltersGroup[] => [
  {
    title: 'Shop metrics',
    param: 'chartEntity',
    items: [
      { label: 'Orders', value: 'ORDERS', checked: false },
      { label: 'Donations', value: 'DONATIONS', checked: false },
      { label: 'Twitch Gifts', value: 'GIVEAWAY', checked: false },
      { label: 'Giveaway links', value: 'GIFTS_ON_CREATOR_COST', checked: false },
      { label: 'Manual charges', value: 'MANUAL', checked: false },
    ],
  },
  {
    title: 'Memberships metrics',
    param: 'chartEntity',
    enabled: membershipsEnabled,
    items: [
      { label: 'Memberships', value: 'SUBSCRIPTIONS', checked: false },
      { label: 'Memberships tip', value: 'MEMBERSHIP_TIP', checked: false },
      { label: 'Memberships locked message', value: 'MEMBERSHIP_LOCKED_MESSAGE', checked: false },
    ],
  },
]

const createOrdersFilters = ({
  membershipsEnabled,
}: {
  membershipsEnabled: boolean
}): AnalyticsFiltersGroup[] => [
  {
    title: 'Shop metrics',
    param: 'chartEntity',
    items: [
      { label: 'Shop orders', value: 'ORDERS', checked: false },
      { label: 'Donations', value: 'DONATIONS', checked: false },
      { label: 'Twitch Gifts', value: 'GIVEAWAY', checked: false },
      { label: 'Giveaway links', value: 'GIFTS_ON_CREATOR_COST', checked: false },
    ],
  },
  {
    title: 'Memberships metrics',
    param: 'chartEntity',
    enabled: membershipsEnabled,
    items: [
      { label: 'Memberships', value: 'SUBSCRIPTIONS', checked: false },
      { label: 'Memberships tip', value: 'MEMBERSHIP_TIP', checked: false },
      { label: 'Memberships locked message', value: 'MEMBERSHIP_LOCKED_MESSAGE', checked: false },
    ],
  },
]

const createMembershipsFilters = ({
  tiers,
  membershipsWlaEnabled,
}: {
  tiers: { label: string; value: string }[]
  membershipsWlaEnabled: boolean
}): AnalyticsFiltersGroup[] => [
  {
    title: 'Subscription cycle',
    param: 'intervals',
    items: [
      { label: 'Month', value: 'Month', checked: false },
      { label: 'Annual', value: 'Year', checked: false },
    ],
  },
  {
    title: 'Tiers',
    param: 'tiersIds',
    items: tiers.map(({ label, value }) => ({ label, value, checked: false })),
  },
  {
    title: 'Subscription origin',
    param: 'devices',
    items: [
      { label: 'Web', value: 'Web', checked: false },
      { label: 'Apple', value: 'Apple', checked: false },
      { label: 'Android', value: 'Android', checked: false },
    ],
    enabled: membershipsWlaEnabled,
  },
]

export const createAnalyticsFilters = ({
  membershipsEnabled,
  membershipsWlaEnabled,
  tiers,
}: {
  membershipsEnabled: boolean
  membershipsWlaEnabled: boolean
  tiers: { label: string; value: string }[]
}): Partial<Record<ReportType, AnalyticsFiltersGroup[]>> => ({
  profit: createProfitFilters({ membershipsEnabled }),
  orders: createOrdersFilters({ membershipsEnabled }),
  'memberships-total-members': createMembershipsFilters({ tiers, membershipsWlaEnabled }),
  'memberships-members-change': createMembershipsFilters({ tiers, membershipsWlaEnabled }),
})
